import React from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, Paper, Typography, Grid, Chip, Divider,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Show.layout = (page) => <AppShell>{page}</AppShell>

const DATA_TYPE_LABELS = {
  decimal: 'Dezimal',
  integer: 'Ganzzahl',
  string: 'Text',
}

export default function Show({ property, attribute_type }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}/unit_attribute_types`

  const handleDelete = () => {
    if (confirm('Attributtyp wirklich löschen?')) {
      router.delete(`${basePath}/${attribute_type.id}`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={attribute_type.name}
        breadcrumbs={[
          { label: 'Attributtypen', href: basePath },
          { label: attribute_type.name },
        ]}
        actions={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" startIcon={<EditIcon />}
              onClick={() => router.visit(`${basePath}/${attribute_type.id}/edit`)}
              data-testid="edit-btn">
              Bearbeiten
            </Button>
            <Button variant="outlined" color="error" startIcon={<DeleteIcon />}
              onClick={handleDelete}
              data-testid="delete-btn">
              Löschen
            </Button>
          </Box>
        }
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Name</Typography>
            <Typography variant="body1">{attribute_type.name}</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Slug</Typography>
            <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{attribute_type.slug}</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Datentyp</Typography>
            <Typography variant="body1">{DATA_TYPE_LABELS[attribute_type.data_type] || attribute_type.data_type}</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Maßeinheit</Typography>
            <Typography variant="body1">{attribute_type.unit_of_measure || '–'}</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Pflicht für WEG</Typography>
            <Typography variant="body1">{attribute_type.required_for_weg ? 'Ja' : 'Nein'}</Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Nutzbar als Verteilerschlüssel</Typography>
            <Typography variant="body1">{attribute_type.usable_as_distribution_key ? 'Ja' : 'Nein'}</Typography>
          </Grid>

          <Grid size={{ xs: 12 }}><Divider /></Grid>

          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Herkunft</Typography>
            <Box sx={{ mt: 0.5 }}>
              {attribute_type.system_attribute_type_name
                ? <Chip label={`System: ${attribute_type.system_attribute_type_name}`} size="small" variant="outlined" />
                : <Chip label="Individuell" size="small" variant="outlined" color="info" />}
            </Box>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="text.secondary">Verwendung</Typography>
            <Typography variant="body2">
              {attribute_type.values_count} Attributwerte, {attribute_type.distribution_keys_count} Verteilerschlüssel
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}
